// Fix for subscription app errors and ensure selling plan is submitted
(function() {
  'use strict';

  // Comprehensive error suppression for subscription app

  // 1. Suppress runtime errors - capture phase for maximum coverage
  window.addEventListener('error', function(e) {
    const errorMsg = e.message || '';
    const filename = e.filename || '';
    const stack = (e.error && e.error.stack) || '';

    if (filename.includes('app-embed-block.js') ||
        errorMsg.includes('app-embed-block.js') ||
        errorMsg.includes('Cannot read properties of null') ||
        errorMsg.includes("reading 'querySelector'") ||
        stack.includes('app-embed-block.js') ||
        stack.includes('updatePriceAndSellingPlanInfo') ||
        stack.includes('showHideSellingPlanForm')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return true;
    }
  }, true);

  // 2. Suppress unhandled promise rejections
  window.addEventListener('unhandledrejection', function(e) {
    const reason = e.reason || {};
    const message = reason.message || reason.toString();
    const stack = reason.stack || '';

    if (message.includes('app-embed-block.js') ||
        message.includes('Cannot read properties of null') ||
        message.includes("reading 'querySelector'") ||
        stack.includes('app-embed-block.js')) {
      e.preventDefault();
      return true;
    }
  });

  // 3. Override console.error to filter out app-embed errors
  const originalConsoleError = console.error;
  console.error = function() {
    const args = Array.from(arguments);
    const errorMessage = args.map(function(arg) {
      if (arg instanceof Error) {
        return arg.message + ' ' + (arg.stack || '');
      }
      return String(arg);
    }).join(' ');

    if (errorMessage.includes('app-embed-block.js') ||
        errorMessage.includes('Cannot read properties of null') ||
        errorMessage.includes("reading 'querySelector'") ||
        errorMessage.includes('updatePriceAndSellingPlanInfo') ||
        errorMessage.includes('showHideSellingPlanForm')) {
      // Silently ignore these errors
      return;
    }

    originalConsoleError.apply(console, args);
  };

  // 3b. Also filter console.warn for fetch abort messages
  const originalConsoleWarn = console.warn;
  console.warn = function() {
    const args = Array.from(arguments);
    const warnMessage = args.join(' ');

    if (warnMessage.includes('Fetch aborted by user')) {
      // Silently ignore fetch abort warnings - this is expected behavior
      return;
    }

    originalConsoleWarn.apply(console, args);
  };

  // 4. Wrap problematic scripts in try-catch
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, listener, options) {
    if (typeof listener === 'function') {
      const wrappedListener = function(event) {
        try {
          return listener.call(this, event);
        } catch (e) {
          const stack = e.stack || '';
          if (stack.includes('app-embed-block.js')) {
            // Suppress app-embed-block.js errors silently
            return;
          }
          throw e;
        }
      };
      return originalAddEventListener.call(this, type, wrappedListener, options);
    }
    return originalAddEventListener.call(this, type, listener, options);
  };

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Monitor for selling plan selection changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          checkForSellingPlanWidget();
        }
      });
    });

    // Observe the subscription container
    const subscriptionContainers = document.querySelectorAll('.subscriptions_app_embed_block');
    subscriptionContainers.forEach(function(container) {
      observer.observe(container, {
        childList: true,
        subtree: true,
        attributes: true
      });
    });

    // Check immediately
    checkForSellingPlanWidget();

    // Verify selling plan matches variant on load
    setTimeout(function() {
      verifySellingPlanMatchesVariant();
    }, 1000);

    // Listen for variant changes to update selling plan (using theme events)
    document.addEventListener('variant:selected', handleVariantChange);
    document.addEventListener('variant:update', handleVariantChange);

    // Also listen for form submissions to ensure selling plan is included
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (form.getAttribute('data-type') === 'add-to-cart-form') {
        ensureSellingPlanIncluded(form);
      }
    }, true);
  }

  function checkForSellingPlanWidget() {
    const sellingPlanInputs = document.querySelectorAll('input[name*="selling_plan"], select[name*="selling_plan"], input[type="radio"][data-selling-plan-id], .rc-option__radio, .rc_widget__option__plans__plan__input');

    if (sellingPlanInputs.length > 0) {
      sellingPlanInputs.forEach(function(input) {
        input.addEventListener('change', function() {
          updateSellingPlanHiddenField();
        });
      });

      updateSellingPlanHiddenField();
    } else {
      setTimeout(checkForSellingPlanWidget, 500);
    }
  }

  function updateSellingPlanHiddenField() {
    const selectedRadio = document.querySelector('input[type="radio"][data-selling-plan-id]:checked') ||
                         document.querySelector('.rc-option__radio:checked') ||
                         document.querySelector('.rc_widget__option__plans__plan__input:checked');
    const selectedSelect = document.querySelector('select[name*="selling_plan"]');
    const hiddenInputs = document.querySelectorAll('input[name="selling_plan"][type="hidden"]');

    if (hiddenInputs.length === 0) return;

    let sellingPlanId = '';

    if (selectedRadio) {
      sellingPlanId = selectedRadio.dataset.sellingPlanId ||
                     selectedRadio.value ||
                     selectedRadio.getAttribute('data-product-selling-plan-id') ||
                     '';
    } else if (selectedSelect) {
      sellingPlanId = selectedSelect.value;
    }

    hiddenInputs.forEach(function(input) {
      input.value = sellingPlanId;
    });
  }

  function ensureSellingPlanIncluded(form) {
    const variantInput = form.querySelector('input[name="id"]');
    const currentVariantId = variantInput ? variantInput.value : null;

    let hiddenInputs = Array.from(form.querySelectorAll('input[name="selling_plan"][type="hidden"]'));

    if (hiddenInputs.length === 0) {
      hiddenInputs = Array.from(document.querySelectorAll('input[name="selling_plan"][type="hidden"]'));
    }

    if (hiddenInputs.length === 0) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'selling_plan';
      form.appendChild(hiddenInput);
      hiddenInputs = [hiddenInput];
    }

    const allSellingPlanRadios = document.querySelectorAll('input[type="radio"][data-selling-plan-id]');
    let correctRadio = null;

    allSellingPlanRadios.forEach(function(radio) {
      const groupId = radio.getAttribute('data-selling-plan-group-id') || '';

      if (currentVariantId && groupId.includes(currentVariantId)) {
        if (radio.checked) {
          correctRadio = radio;
        } else if (!correctRadio) {
          correctRadio = radio;
        }
      }
    });

    const selectedRadio = form.querySelector('input[type="radio"][data-selling-plan-id]:checked') ||
                         document.querySelector('input[type="radio"][data-selling-plan-id]:checked') ||
                         document.querySelector('.rc-option__radio:checked') ||
                         document.querySelector('.rc_widget__option__plans__plan__input:checked');
    const selectedSelect = form.querySelector('select[name*="selling_plan"]') ||
                          document.querySelector('select[name*="selling_plan"]');

    let sellingPlanId = '';

    if (correctRadio) {
      sellingPlanId = correctRadio.dataset.sellingPlanId || '';
    } else if (selectedRadio) {
      sellingPlanId = selectedRadio.dataset.sellingPlanId ||
                     selectedRadio.value ||
                     selectedRadio.getAttribute('data-product-selling-plan-id') ||
                     '';
      const selectedGroupId = selectedRadio.getAttribute('data-selling-plan-group-id') || '';

      if (currentVariantId && !selectedGroupId.includes(currentVariantId)) {
        sellingPlanId = '';
      }
    } else if (selectedSelect && selectedSelect.value) {
      sellingPlanId = selectedSelect.value;
    }

    hiddenInputs.forEach(function(input) {
      input.value = sellingPlanId;
    });
  }

  function handleVariantChange() {
    setTimeout(function() {
      const variantInput = document.querySelector('input[name="id"]');
      const currentVariantId = variantInput ? variantInput.value : null;

      const sellingPlanRadios = document.querySelectorAll('input[type="radio"][data-selling-plan-id]');
      let matchingRadios = [];
      let firstMatchingRadio = null;

      sellingPlanRadios.forEach(function(radio) {
        const groupId = radio.getAttribute('data-selling-plan-group-id') || '';

        if (currentVariantId && groupId.includes(currentVariantId)) {
          matchingRadios.push(radio);

          if (!firstMatchingRadio) {
            firstMatchingRadio = radio;
          }

          if (radio.checked) {
            updateSellingPlanHiddenField();
            return;
          }
        }
      });

      if (matchingRadios.length > 0 && !matchingRadios.some(r => r.checked)) {
        firstMatchingRadio.checked = true;
        const changeEvent = new Event('change', { bubbles: true });
        firstMatchingRadio.dispatchEvent(changeEvent);
        updateSellingPlanHiddenField();
      }
    }, 500);
  }

  function monitorVariantInput() {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      const variantObserver = new MutationObserver(function() {
        handleVariantChange();
      });

      variantObserver.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });

      variantInput.addEventListener('change', handleVariantChange);
    } else {
      setTimeout(monitorVariantInput, 500);
    }
  }

  monitorVariantInput();

  function verifySellingPlanMatchesVariant() {
    const variantInput = document.querySelector('input[name="id"]');
    const currentVariantId = variantInput ? variantInput.value : null;

    if (!currentVariantId) return;

    const sellingPlanRadios = document.querySelectorAll('input[type="radio"][data-selling-plan-id]');
    const checkedRadio = Array.from(sellingPlanRadios).find(r => r.checked);

    if (!checkedRadio) return;

    const groupId = checkedRadio.getAttribute('data-selling-plan-group-id') || '';

    if (!groupId.includes(currentVariantId)) {
      let correctRadio = null;
      sellingPlanRadios.forEach(function(radio) {
        const radioGroupId = radio.getAttribute('data-selling-plan-group-id') || '';
        if (radioGroupId.includes(currentVariantId) && !correctRadio) {
          correctRadio = radio;
        }
      });

      if (correctRadio) {
        correctRadio.checked = true;
        const changeEvent = new Event('change', { bubbles: true });
        correctRadio.dispatchEvent(changeEvent);
        updateSellingPlanHiddenField();
      }
    }
  }
})();
